import { CircularProgress, Typography } from "@mui/material"
import { translate } from "app/language/service"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { IUserRole } from "user/model"
import { getUserRoles } from "user/tools/permissions"

export interface IUserRolesProps {
  userId: number
}

export const UserRoles = React.memo(({ userId }: IUserRolesProps): JSX.Element => {
  const [roles, setRoles] = React.useState<IUserRole[] | null>(null)
  const [hasError, setHasError] = React.useState(false)
  React.useEffect(() => {
    getUserRoles(userId)
      .then(newRoles => {
        setRoles(newRoles)
      })
      .catch(error => {
        console.error(error)
        setHasError(true)
      })
  }, [])
  if (hasError) {
    return (
      <Typography fontSize=".75rem" color="error">
        {translate("label.error")}
      </Typography>
    )
  }
  if (roles === null) {
    return <CircularProgress sx={{ color: theme => theme.palette.primary.main }} size="1.5rem" />
  }
  if (roles.length === 0) {
    return (
      <Typography fontSize=".75rem" color="textPrimary">
        -
      </Typography>
    )
  }
  return (
    <FlexBox gap=".5rem" wrap>
      {roles.map((r, index) => (
        <Typography
          key={index}
          fontSize=".75rem"
          color="textPrimary"
          sx={{ border: theme => theme.palette.border, borderRadius: ".5rem", pr: ".2rem", pl: ".2rem" }}>
          {translate(`user.role.${r}`)}
        </Typography>
      ))}
    </FlexBox>
  )
})
